import Modal from 'react-modal'
import { colors } from 'app-v2/design-systems/theme'
import React from 'react'
import 'webrtc-adapter'
import { Layout } from 'app/ecommerce/common'
import type { ScannerProps } from './Scanner'
import { Scanner } from './Scanner'
import { modalStyle } from './styles'

type Props = {
    open: boolean
} & ScannerProps

export const QRCodeScannerModal = (props: Props) => {
    return (
        <Modal isOpen={props.open} style={modalStyle}>
            <Layout
                background={colors.mayoEggWhite}
                border
                showLogoBK
                closeEnabled
                onClose={props.onClose}>
                <Scanner
                    onClose={props.onClose}
                    onScan={props.onScan}
                    helpText={props.helpText}
                    idleColor={props.idleColor}
                />
            </Layout>
        </Modal>
    )
}
